// extracted by mini-css-extract-plugin
module.exports = {"titleText":"e_Jw","container":"e_Kw","authorText":"e_Lw","title":"e_Mw","image":"e_Nw","description":"e_Ow","author":"e_Pw","splitLine":"e_Qw"};